var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    {
      attrs: {
        "no-gutters": "",
        "justify-md": "center"
      }
    },
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            md: "9"
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center mt-md-8 mb-2 mb-md-11",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("h2", [
                    _vm._v(" Refer A Friend and Earn up to $100 Per Referral ")
                  ])
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-row",
                    {
                      attrs: {
                        "no-gutters": "",
                        justify: "center"
                      }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "8"
                          }
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              src:
                                "/static/img/amui/enroll-greengeeks-affiliate-program.png"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0 text-justify"
                    },
                    [
                      _vm._v(
                        " The GreenGeeks web hosting affiliate program is one of the most rewarding & highest paying affiliate programs available on the Internet today. Join over 20,000 affiliates and help promote one of the fastest growing web hosting brands on the Internet. Not only will you be promoting a great web hosting service, but you'll also be spreading our green message to help make the Internet a greener medium. "
                      )
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-row",
                    {
                      attrs: {
                        "no-gutters": ""
                      }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled"
                            },
                            [
                              _c(
                                "li",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "20"
                                      }
                                    },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(" Free to Join ")
                                ],
                                1
                              ),
                              _c(
                                "li",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "20"
                                      }
                                    },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(" Dedicated Affiliate Team ")
                                ],
                                1
                              ),
                              _c(
                                "li",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "20"
                                      }
                                    },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(
                                    " Wide Selection of Creatives, Content & Banners "
                                  )
                                ],
                                1
                              ),
                              _c(
                                "li",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "20"
                                      }
                                    },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(" Unique Affiliate Tracking URL ")
                                ],
                                1
                              ),
                              _c(
                                "li",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "20"
                                      }
                                    },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(" Targeted Landing Pages ")
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled"
                            },
                            [
                              _c(
                                "li",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "20"
                                      }
                                    },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(" Custom Campaign Tracking ")
                                ],
                                1
                              ),
                              _c(
                                "li",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "20"
                                      }
                                    },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(" Advanced Real-time Statistics ")
                                ],
                                1
                              ),
                              _c(
                                "li",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "20"
                                      }
                                    },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(
                                    " Competitive Commissions for Performers "
                                  )
                                ],
                                1
                              ),
                              _c(
                                "li",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "20"
                                      }
                                    },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(" and much, much more. ")
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "justify-center"
            },
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "8",
                    md: "5",
                    lg: "4"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "justify-center"
                    },
                    [
                      _c("gg-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: _vm.rules.describes,
                            expression: "rules.describes"
                          }
                        ],
                        attrs: {
                          outlined: "",
                          label: "What Best Describes You",
                          items: _vm.items,
                          "data-vv-name": "describes",
                          "data-vv-as": "What Best Describes You",
                          "error-messages": _vm.errors.collect("describes")
                        },
                        model: {
                          value: _vm.model.describes,
                          callback: function callback($$v) {
                            _vm.$set(_vm.model, "describes", $$v)
                          },
                          expression: "model.describes"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "justify-center"
            },
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "8",
                    md: "5",
                    lg: "4"
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: _vm.rules.paypal_address,
                            expression: "rules.paypal_address"
                          }
                        ],
                        attrs: {
                          label: "Payment Method: PayPal",
                          placeholder: "Enter Your PayPal Email Address",
                          "data-vv-name": "paypal_address",
                          "data-vv-as": "PayPal Address",
                          "error-messages": _vm.errors.collect("paypal_address")
                        },
                        model: {
                          value: _vm.model.paypal_address,
                          callback: function callback($$v) {
                            _vm.$set(_vm.model, "paypal_address", $$v)
                          },
                          expression: "model.paypal_address"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-center"
                    },
                    [
                      _c("v-checkbox", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required:true",
                            expression: "'required:true'"
                          }
                        ],
                        staticClass: "mt-0",
                        attrs: {
                          "data-vv-name": "Agreement",
                          "data-vv-as": "Agreement",
                          "error-messages": _vm.errors.collect("Agreement"),
                          color: "primary"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function fn() {
                              return [
                                _c(
                                  "div",
                                  [
                                    _vm._v(" I agree to the "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          bottom: ""
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "activator",
                                            fn: function fn(_ref) {
                                              var on = _ref.on
                                              return [
                                                _c(
                                                  "a",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        target: "_blank",
                                                        href:
                                                          "https://www.greengeeks.com/legal/atoc"
                                                      },
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      " Affiliate Terms of Service "
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      },
                                      [_vm._v(" Opens in new tab ")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.agreement,
                          callback: function callback($$v) {
                            _vm.agreement = $$v
                          },
                          expression: "agreement"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        "x-large": "",
                        loading: _vm.loading
                      },
                      on: {
                        click: _vm.join
                      }
                    },
                    [_vm._v("Join Now")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }